import React, { useState, useEffect, useContext } from "react";
import { auth_forgot_password } from "../../assets/images";
import { Link, useNavigate } from "react-router-dom";
import RecaptchaComponent from "../../components/RecaptchaComponent";
import { AuthServiceContext } from "../../services/auth/authService";
import { useUserContext } from "../../context/user_context";
import CustomAlert from "../../components/CustomAlert";
import Cookies from "js-cookie";

export default function ForgotPassword() {
  const [formData, setFormData] = useState({
    info: "",
    recaptchaCode: "",
  });
  const navigate = useNavigate();
  const [resetCaptcha, setResetCaptcha] = useState(false);

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });

  const { captchaState, setCaptchaState, send } = useUserContext();
  const [errors, setErrors] = useState({});

  const { resetPasswordRequest } = useContext(AuthServiceContext);

  const setCookieWithExpiration = (key, value, expirationInMinutes) => {
    const expirationInDays = expirationInMinutes / 1440; // Convert minutes to days
    Cookies.set(key, value, { expires: expirationInDays });
  };

  useEffect(() => {
    setCaptchaState({ ask: true, token: captchaState.token });
  }, []);

  const handleResetPasswordRequest = async () => {
    const response = await resetPasswordRequest({
      info: formData.info,
      recaptchaCode: captchaState.token,
    });

    if (!response.success) {
      //setStep(2);
      setResetCaptcha(!resetCaptcha);
      setAlertConfig({
        show: true,
        title: "შეცდომა",
        text: response.message,
        icon: "error",
        onConfirm: () => {
          setAlertConfig({ ...alertConfig, show: false });
        },
      });
    } else {
      setCookieWithExpiration("resetPasswordInfo", formData.info, 10);
      navigate("/auth-forgot-password-step-2");
    }
  };

  const validateForm = () => {
    let valid = true;
    let formErrors = {};

    if (!formData.info) {
      valid = false;
      formErrors.info = "მომხმარებლის სახელი აუცილებელია";
    }

    if (
      !captchaState.token ||
      captchaState.token === "" ||
      captchaState.token === null ||
      captchaState.token === undefined
    ) {
      //alert("Recaptcha is required");
      valid = false;
      formErrors.recaptchaCode = "მონიშნეთ reCAPTCHA";
    }

    setErrors(formErrors);
    //console.log(formErrors);
    return valid;
  };

  const handleRequestSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateForm();
    if (!isValid) return;
    await handleResetPasswordRequest();
  };

  return (
    <>
      <CustomAlert {...alertConfig} />
      <form onSubmit={handleRequestSubmit}>
        <div className="flex justify-center sm:mb-6 mb-4">
          <img
            src={auth_forgot_password}
            width="240"
            height="178"
            alt="forgot password"
          />
        </div>
        <p className="sm:text-[40px]/[48px] text-[30px]/[36px] font-medium mb-2 text-center">
          დაგავიწყდა პაროლი?
        </p>

        <div className="form-control mb-20">
          <label htmlFor="email" className="form-label">
            მომხმარებლის სახელი
          </label>
          <input
            type="text"
            id="username"
            name="info"
            placeholder="მომხმარებლის სახელი"
            className="form-input"
            onChange={(e) => {
              setFormData({ ...formData, info: e.target.value });
            }}
          />
          {errors.info && (
            <div className="text-danger text-[14px]/[20px]">{errors.info}</div>
          )}
        </div>
        <div className="">
          {captchaState.ask && (
            <>
              <div
                className="flex mb-20"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div className="auth-err-cont" style={{ marginTop: "10px" }}>
                  <RecaptchaComponent reset={resetCaptcha} />
                </div>
                {errors.recaptchaCode && (
                  <div className="text-danger text-[14px]/[20px]">
                    {errors.recaptchaCode}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <button
          type={"submit"}
          className="btn btn-secondary large w-full uppercase"
        >
          შემდეგი
        </button>
        <div className="text-center sm:mt-30 mt-6">
          <Link to="/auth-signin" className="text-primary">
            ავტორიზაციაზე დაბრუნება
          </Link>
        </div>
      </form>
    </>
  );
}
